import { render, staticRenderFns } from "./company_item_info_us.vue?vue&type=template&id=516b52d9"
import script from "./company_item_info_us.vue?vue&type=script&lang=js"
export * from "./company_item_info_us.vue?vue&type=script&lang=js"
import style0 from "./company_item_info_us.vue?vue&type=style&index=0&id=516b52d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports